/**
 * Default quickshop options
 *
 * @see launchQuickshopUtils.js for options
 */
export const defaultQuickshopOptions = {
    ownerView: false,
    shopperView: false,
    wrapPagination: false,
    showAddToWishlist: true,
    showAddToFavorites: true,
    showAddToRegistry: false,
    collapseAccordions: true,

    hideRequestSwatch: true
};
